import * as React from "react";
export const HotKeyHandler = ({ keyMapping, onCall }) => {
    const handleKeyRun = (e) => {
        for (const hotkeys in keyMapping) {
            if (keyMapping[hotkeys].secondKey === e.key && e.altKey && !e.repeat) {
                onCall();
            }
        }
    };
    React.useEffect(() => {
        window.addEventListener("keydown", handleKeyRun);
        return () => {
            window.removeEventListener("keydown", handleKeyRun);
        };
    }, [keyMapping, onCall]);
    return null;
};
//# sourceMappingURL=HotkeyHandler.js.map